var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.$.plan_item,
        _vm.planData.name,
        _vm.isPopup ? _vm.$.popup_item : _vm.$.page_item,
      ],
    },
    [
      _c("div", { class: _vm.$.title }, [
        _c(
          "div",
          { class: _vm.$.plan_name, style: { textTransform: "capitalize" } },
          [_vm._v("\n      " + _vm._s(_vm.planData.plan_name) + "\n    ")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.$.description }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.locales(_vm.planData.plan_title_locale + "_plan_info_locale")
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _vm.planData.plan_name !== "enterprise"
        ? _c("div", { class: [_vm.$.price, _vm.$.action_box] }, [
            _c("div", { class: _vm.$.panel }, [
              _c("div", { class: _vm.$.usd }, [
                _c("span", { class: _vm.$.usd__currency }, [_vm._v("$")]),
                _c("span", { class: _vm.$.usd__price }, [
                  _vm._v(_vm._s("" + _vm.planData.price)),
                ]),
                _c("span", { class: _vm.$.usd__label }, [_vm._v("USD")]),
              ]),
              _vm._v(" "),
              _c("div", { class: _vm.$.description }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.isAnnual
                        ? "" + _vm.locales("per_user_billed_annually_locale")
                        : _vm.locales("per_user_locale") +
                            " " +
                            _vm.locales("per_month_key")
                    ) +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            !_vm.isPopup || _vm.isTrial
              ? _c(
                  "div",
                  {
                    class: [_vm.$.btn, _vm.$.upgrade_btn],
                    on: {
                      click: function ($event) {
                        return _vm.buyPlanClick(_vm.planData)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.locales("upgrade_now_btn_locale")) +
                        "\n    "
                    ),
                  ]
                )
              : _vm.isPopup && !_vm.planData.isCurrentPaymentPlan
              ? _c(
                  "div",
                  {
                    class: [_vm.$.btn, _vm.$.upgrade_btn],
                    on: {
                      click: function ($event) {
                        return _vm.upgradePlanClick(_vm.planData)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.locales("upgrade_now_btn_locale")) +
                        "\n    "
                    ),
                  ]
                )
              : _vm.isPopup && _vm.planData.isCurrentPaymentPlan
              ? _c(
                  "div",
                  { class: [_vm.$.current_plan_sticker, _vm.planData.name] },
                  [
                    _c("webix-ui", {
                      class: _vm.$.plan_check_icon,
                      attrs: { config: _vm.icons.check },
                    }),
                    _vm._v(" "),
                    _c("div", { class: _vm.$.sticker_text }, [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.locales("current_plan")) +
                          "\n      "
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _c("div", { class: [_vm.$.demo, _vm.$.action_box] }, [
            _c("div", { class: _vm.$.panel }, [
              _c("div", { class: _vm.$.demo_title }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.locales("pricing_custom_price_title")) +
                    "\n      "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                class: [_vm.$.btn, _vm.$.demo_btn],
                on: { click: _vm.demoClick },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.locales("demo_btn_locale")) + "\n    "
                ),
              ]
            ),
          ]),
      _vm._v(" "),
      _c(
        "div",
        {
          class: _vm.$.plan_features,
          style: { height: _vm.heights.featuresSection + "px" },
        },
        [
          _c("div", {
            ref: "featuresDesc",
            class: _vm.$.features_desc,
            domProps: {
              innerHTML: _vm._s(_vm.getPlanFeaturesListTitle(_vm.planData)),
            },
          }),
          _vm._v(" "),
          _c("ul", { ref: "featuresList", class: _vm.$.features_list }, [
            _c("li", { class: _vm.$.item }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.locales(_vm.planData.plan_title_locale + "_feature_1")
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.$.item }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.locales(_vm.planData.plan_title_locale + "_feature_2")
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.$.item }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.locales(_vm.planData.plan_title_locale + "_feature_3")
                  ) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { class: _vm.$.item }, [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.locales(_vm.planData.plan_title_locale + "_feature_4")
                  ) +
                  "\n      "
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          class: [_vm.$.about_plan_link, _vm.$.link],
          attrs: {
            href:
              _vm.isPopup === true
                ? _vm.locales(
                    "about_plan_href_" + _vm.planData.plan_title_locale
                  )
                : "#features",
            target: _vm.isPopup === true ? "_blank" : null,
          },
          on: {
            click: function ($event) {
              return _vm.linkClick(_vm.planData.plan_name)
            },
          },
        },
        [
          [
            _vm._v(
              "\n      " + _vm._s(_vm.locales("about_link_compare")) + "\n    "
            ),
          ],
          _vm._v(" "),
          _c(
            "svg",
            {
              attrs: {
                width: "20",
                height: "12",
                viewBox: "0 0 20 12",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M14.5 1.5L19 6M19 6L14.5 10.5M19 6H1",
                  stroke: "#1565C0",
                  "stroke-width": "1.5",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                },
              }),
            ]
          ),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }